import { type FC } from 'react'
interface CoHostTagProps {
  label: string
}

export const CoHostTag: FC<CoHostTagProps> = ({ label }) => (
  <span className='paragraph-small zocks-bg-color-warning text-warning-emphasis rounded-3 px-2 py-1 text-nowrap'>{label}</span>
)
